import { cn } from "~/lib/utils";

interface PanelSectionTitleProps {
  children: React.ReactNode;
  className?: string;
}

export function PanelSectionTitle({ children, className }: PanelSectionTitleProps) {
  return (
    <div className={cn("px-6 text-xs font-medium text-muted-foreground uppercase tracking-wide", className)}>
      {children}
    </div>
  );
}
